import { required, email, helpers } from 'vuelidate/lib/validators'
const phoneCheck = helpers.regex('phoneCheck', /^\+\d{1,18}$/)
const requiredMsg = 'Обязательное поле'
export default (ctx) => {
  return {
    name: { required: { validator: required, message: requiredMsg } },
    surname: { required: { validator: required, message: requiredMsg } },
    phone: {
      required: { validator: required, message: requiredMsg },
      phoneCheck: { validator: phoneCheck, message: 'Неверный формат номера' }
    },
    email: {
      required: { validator: required, message: requiredMsg },
      email: { validator: email, message: 'Неверный формат email адреса' }
    }
  }
}
